export const isProduction = process.env.NODE_ENV === 'production'

export const MAPGL_ACCESS_TOKEN =
  'pk.eyJ1Ijoic3ZlaW5ubWFyIiwiYSI6ImNsN2thZ3RyajAwc2Qzdm1reWZxamY0Zm4ifQ.ArD0ulWIvDXCMTI-ZB4liQ'
